module.exports = "<div><input class= \"mwInputNode mwAlignmentNode\" spellcheck=\"false\" type=\"text\" data-dojo-attach-point=\"inputNode,focusNode\"></div>"